export default {
  rewards: {
    title: "Recompensas",
    claim: "Reivindicar",
    weeklyCashback: "Reembolso Semanal",
    weeklyCashbackDesc: "Receba de volta uma parte das suas perdas semanais toda semana.",
    dailySpin: "Giro Diário",
    dailySpinDesc: "Gire a roleta diariamente para ter a chance de ganhar grandes prêmios.",
    invitationBonus: "Bônus de Convite",
    invitationBonusDesc: "Convide amigos e ganhe recompensas para cada um que se cadastrar.",
    rebate: "Rebate",
    rebateDesc: "Ganhe rebates em cada aposta feita, ganhando ou perdendo.",
    bannerTitle: "RECOMPENSAS",
    bannerSubtitle: "Complete tarefas e ganhe recompensas incríveis!",
    sectionTitle: "Suas Recompensas Incríveis",
    goNow: "Ir Agora",
    historyReceived: "Total recebido",
    todayReceived: "Recebido hoje",
    cashbackDialog: {
      title: "Cashback de Aposta",
      loading: "Carregando...",
      empty: "Sem regras de cashback",
      level: "Nível",
      amountRange: "Faixa de Valor",
      rewardRate: "Taxa de Recompensa",
      rewardCap: "Limite de Recompensa",
    },
    cards: {
      checkin: {
        title: "Check-in Diário",
        subtitle: "Faça login para fazer check-in diariamente",
        description: "Jogadores, lembrem-se de fazer check-in todos os dias~",
      },
      cashback: {
        title: "Reembolso",
        subtitle: "Recompensas de rebate da plataforma",
      },
      rescue: {
        title: "Bônus de Resgate",
        subtitle: "Jogue 3 jogos com dinheiro",
        description: "Fundos de resgate para jogadores falidos",
      },
      task: {
        title: "Tarefas",
        subtitle: "Complete tarefas da plataforma",
        description: "Tarefas da plataforma",
      },
      balance: {
        title: "Cofre",
        subtitle: "Ganhe juros diariamente",
        description: "Cofre da plataforma",
      },
      loan: {
        title: "Bônus de Empréstimo",
        subtitle: "Empreste com facilidade",
        description: "Empréstimo da plataforma",
      },
    },
    checkIn: {
      dailySignIn: "CHECK-IN DIÁRIO",
      totalRewards: "RECOMPENSAS TOTAIS",
      headlineDaysBefore: "Faça check-in por",
      headlineDaysAfter: "dias,",
      headlineTailCumulative: "não importa se perder um dia.",
      headlineTailDate: "perder um dia significa perder a recompensa desse dia.",
      headlineCumulative: "Faça check-in por {days} dias para ganhar muito, não importa se perder um dia.",
      headlineDate: "Faça check-in por {days} dias, perder um dia significa perder a recompensa desse dia.",
      headlineEmpty: "Faça check-in para ganhar recompensas",
      title: "Check-in",
      modeCumulative: "Check-in Cumulativo",
      modeDate: "Check-in por Data",
      rewards: "Recompensas",
      signedIn: "Check-in feito",
      day: "Dia {n}",
      loading: "Carregando...",
      empty: "Nenhuma atividade de check-in ativa.",
      btnCheckIn: "Check-in",
      btnSigned: "Já feito",
      btnLocked: "Bloqueado",
      claimSuccess: "Check-in realizado, recompensa de {amount} {currency} creditada",
      claimFailed: "Falha no check-in",
      alreadySigned: "Você já fez check-in hoje",
      notLogin: "Por favor, faça login primeiro",
    },
  },
};
